import React from 'react';
import { StyledTinyLoader } from './TinyLoader.styled';
import { TinyLoaderProps } from './TinyLoader.types';


export const TinyLoader = (props: TinyLoaderProps) => {
    return <StyledTinyLoader {...props} data-testid="tiny-loader" />;
};

